"use client"

import { ControlledModal } from "@/components"
import { Button } from "@/elements"
import { DocumentNode } from "@apollo/client"
import { FC } from "react"
import { useWithdrawApplicationMutation } from "./useWithdrawApplicationMutation"

interface Props {
  applicationId: string
  trigger?: React.ReactNode
  onOpenChange: (isOpen: boolean) => void
  isOpen: boolean
  withdrawMutationRefetchQueries: DocumentNode[]
  showAdditionalOverlay?: boolean
  onComplete?: () => void
}

export const WithdrawApplicationModal: FC<Props> = props => {
  const {
    applicationId,
    trigger,
    onOpenChange,
    isOpen,
    showAdditionalOverlay = false,
    withdrawMutationRefetchQueries,
    onComplete,
  } = props

  const { handleWithdrawApplication, loading } = useWithdrawApplicationMutation({
    applicationId,
    onComplete: () => {
      onOpenChange(false)
      onComplete?.()
    },
    refetchQueries: withdrawMutationRefetchQueries,
  })

  return (
    <>
      {trigger || (
        <>
          <Button
            size="large"
            className="hidden md:block"
            variant="tertiary"
            onClick={e => {
              e.preventDefault()
              e.stopPropagation()
              onOpenChange(true)
            }}>
            Withdraw
          </Button>
          <Button
            className="md:hidden"
            variant="tertiary"
            onClick={e => {
              e.preventDefault()
              e.stopPropagation()
              onOpenChange(true)
            }}>
            Withdraw
          </Button>
        </>
      )}

      <ControlledModal
        open={isOpen}
        onOpenChange={onOpenChange}
        variant="warning"
        zIndex={102}
        header={{
          title: "Are you sure?",
          subtitle:
            "Withdrawing your application will remove you from consideration for this active role. Your application will move to the archived tab.",
          variant: "warning",
          fixed: true,
        }}
        footer={{
          fixed: true,
          tertiaryButton: {
            children: "Cancel",
            onClick: e => {
              e.preventDefault()
              e.stopPropagation()
              onOpenChange(false)
            },
          },
          primaryButton: {
            children: "Withdraw application",
            variant: "error",
            loading: loading,
            onClick: e => {
              e.preventDefault()
              e.stopPropagation()
              handleWithdrawApplication()
            },
          },
        }}
      />
    </>
  )
}
